export default class GeoData{
  constructor (size, stepθ=1, stepφ=1) {
    this.nθ = size[0];
    this.nφ = size[1];

    this.size = size;

    this.stepθ = stepθ;
    this.stepφ = stepφ;
  }

  /**
  * @return {Value} nearest θ,φ point value (θ,φ spherical coordinates)
  */
  getValue(θφ) {
    if (!θφ) {
      return null;
    }
    let closestPoint = this.getClosestPoint(θφ);
    if (!closestPoint) {
      return null;
    }
    return this.data[closestPoint[0]][closestPoint[1]];
  }

  /**
  * @return {Value} bilinear interpolation at θ,φ (spherical coordinates)
  *
  */
  interpolateValue(θφ) {
    if (!θφ) {
      return null;
    }
    let interpPoints = this.getInterpolationPoints(θφ);
    if (!interpPoints) {
      return null;
    }
    let [flooriθ,ceiliθ,flooriφ,ceiliφ,Δθ,Δφ,rθ,rφ] = interpPoints;
    return this.data[flooriθ][flooriφ] * rθ * rφ +
           this.data[ceiliθ][flooriφ] * Δθ * rφ +
           this.data[flooriθ][ceiliφ] * rθ * Δφ +
           this.data[ceiliθ][ceiliφ] * Δθ * Δφ;
  }

  getMean() {
    var mean = 0;
    for (var iθ=0;iθ<this.nθ;iθ++) {
      for (var iφ=0;iφ<this.nφ;iφ++) {
        mean += this.data[iθ][iφ];
      }
    }
    return mean / (this.nθ * this.nφ);
  }

  //return data index ()
  θtoIndex(θ) {
    return θ/this.stepθ -1;
  }

  φtoIndex(φ) {
    return (φ%360)/this.stepφ;
  }

  θφtoIndices(θφ) {
    return [this.θtoIndex(θφ[0]),this.φtoIndex(θφ[1])];
  }

  //return point from index ()
  indexToθ(iθ) {
    return (iθ+1)*this.stepθ;
  }

  indexToφ(iφ) {
    return (iφ)*this.stepφ;
  }

  indexToθφ(iθiφ) {
    return [this.indexToθ(iθiφ[0]),this.indexToφ(iθiφ[1])];
  }

  getInterpolationPoints(θφ){
    let θ = θφ[0];
    let φ = θφ[1];
    let iθ = this.θtoIndex(θ);
    let iφ = this.φtoIndex(φ);
    if ((iθ < 0) || (iθ > this.nθ-1) || (iφ < 0) || (iφ > this.nφ)) {
      return null; //out of bound
    }
    let flooriθ = Math.floor(iθ);
    let flooriφ = Math.floor(iφ);
    let ceiliθ = Math.ceil(iθ);
    let ceiliφ = Math.ceil(iφ) % this.nφ; // Continuous in phi
    let Δθ = (θ - this.indexToθ(flooriθ))/this.stepθ; let Δφ = (φ - this.indexToφ(flooriφ))/this.stepφ;
    let rθ = (1 - Δθ); let rφ = (1 - Δφ);
    return [flooriθ,ceiliθ,flooriφ,ceiliφ,Δθ,Δφ,rθ,rφ];
  }

  getClosestPoint(θφ){
    let iθ = Math.round(this.θtoIndex(θφ[0]));
    let iφ = Math.round(this.φtoIndex(θφ[1]));
    if ((iθ < 0) || (iθ > this.nθ-1) || (iφ < 0) || (iφ > this.nφ)) {
      return null; //out of bound
    }
    return [iθ,iφ%this.nφ];
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/model/geoData.js
// module id = 11
// module chunks = 0